// Harta observatiilor (fisa de testare B1) - pagina /map (observation/map.html)
// si mini-harta din detaliile observatiei (fragments/gps-details :: minimapRow).
// Fisier SEPARAT de app.js: Leaflet + acest cod se incarca doar unde e nevoie
// (pe /map direct din template; mini-harta il cere la cerere, prin
// initMinimaps() din app.js), nu pe fiecare pagina a aplicatiei.
// Aspectul urmeaza mockup-urile decise 2026-09-30 (docs/mockup-map-*.html).
(function () {
    'use strict';

    // aceleasi iconite ca pe Acasa / Listarea Observatii
    var TYPE_ICONS = {
        PHENOLOGY: 'bi-flower1',
        DISTURBANCE: 'bi-exclamation-triangle-fill',
        SOIL: 'bi-layers-fill'
    };
    var TYPE_ORDER = ['PHENOLOGY', 'DISTURBANCE', 'SOIL'];
    // culoarea fiecarui tip in inelul grupurilor (aceleasi variabile ca .map-type-*)
    var TYPE_RING_COLORS = {
        PHENOLOGY: 'var(--bs-success)',
        DISTURBANCE: 'var(--bs-warning)',
        SOIL: 'var(--map-soil-color)'
    };
    var STATUS_PENDING = 1;
    var STATUS_REJECTED = 3;
    var STATUS_COUNT = 3;
    // starea se vede DOAR prin glifa din colt (decizie 2026-09-30); aprobatul nu are glifa
    var STATUS_GLYPHS = { 1: 'bi-clock-fill', 3: 'bi-x-circle-fill' };

    // Parcul National Calimani - centrul implicit cand nu exista niciun punct
    var DEFAULT_CENTER = [47.10, 25.22];
    var DEFAULT_ZOOM = 11;
    var FOCUS_ZOOM = 17;
    var MARKER_SIZE = 34;
    var NEAR_MARKER_SIZE = 24;

    var OSM_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';
    var TOPO_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>, SRTM | '
        + '&copy; <a href="https://opentopomap.org">OpenTopoMap</a> (CC-BY-SA)';

    function escapeHtml(value) {
        return String(value == null ? '' : value)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function format(template, args) {
        return String(template).replace(/\{(\d+)\}/g, function (match, index) {
            return args[index] != null ? args[index] : match;
        });
    }

    // pluralul romanesc: 1 observatie / 2-19 (si 101-119...) observatii / 20+ "de" observatii
    function plural(n, one, few, many, extraArgs) {
        var args = [n].concat(extraArgs || []);
        if (n === 1) return format(one, args);
        var rest = n % 100;
        return format((n === 0 || (rest >= 1 && rest <= 19)) ? few : many, args);
    }

    function cssVar(name) {
        return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    }

    // Referer explicit pe tile-uri: proxy-ul de pe cali_test (sec@docker) pune
    // Referrer-Policy: no-referrer pe pagina, iar OSM respinge cererile fara
    // Referer (403 "Access blocked"). Atributul de pe <img> are prioritate fata
    // de politica documentului; se trimite doar originea, nu calea.
    var TILE_REFERRER_POLICY = 'strict-origin-when-cross-origin';

    function standardLayer() {
        return L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png',
            { maxZoom: 19, attribution: OSM_ATTRIBUTION, referrerPolicy: TILE_REFERRER_POLICY });
    }

    function topoLayer() {
        return L.tileLayer('https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
            { maxZoom: 17, attribution: TOPO_ATTRIBUTION, referrerPolicy: TILE_REFERRER_POLICY });
    }

    // ---------- markere ----------

    function markerHtml(point, extraClass) {
        var glyph = point.status != null ? STATUS_GLYPHS[point.status] : null;
        var classes = 'map-marker map-type-' + point.type
            + (point.status === STATUS_REJECTED ? ' map-marker-rejected' : '')
            + (extraClass ? ' ' + extraClass : '');
        return '<div class="' + classes + '">'
            + '<div class="map-marker-body"><i class="bi ' + TYPE_ICONS[point.type] + '"></i></div>'
            + (point.sentinel ? '<div class="map-marker-sentinel"><i class="bi bi-tree-fill"></i></div>' : '')
            + (glyph ? '<div class="map-marker-status"><i class="bi ' + glyph + '"></i></div>' : '')
            + '</div>';
    }

    // pin (picatura rotita) - varful e in coltul de jos, deci ancora e sub marker
    function markerIcon(point, size, extraClass) {
        return L.divIcon({
            className: '',
            html: markerHtml(point, extraClass),
            iconSize: [size, size],
            iconAnchor: [size / 2, size + 2],
            popupAnchor: [0, -size],
            tooltipAnchor: [size / 2, -size / 2]
        });
    }

    function clusterHtml(points, authenticated) {
        var total = points.length;
        var counts = {};
        var pending = 0;
        points.forEach(function (point) {
            counts[point.type] = (counts[point.type] || 0) + 1;
            if (point.status === STATUS_PENDING) pending++;
        });
        var stops = [];
        var start = 0;
        TYPE_ORDER.forEach(function (type) {
            if (!counts[type]) return;
            var end = start + counts[type] / total * 100;
            stops.push(TYPE_RING_COLORS[type] + ' ' + start + '% ' + end + '%');
            start = end;
        });
        var badge = authenticated && pending
            ? '<div class="map-cluster-pending"><i class="bi bi-clock-fill"></i> ' + pending + '</div>' : '';
        return '<div class="map-cluster" style="background: conic-gradient(' + stops.join(', ') + ')">'
            + '<div class="map-cluster-inner">' + total + '</div>' + badge + '</div>';
    }

    function clusterSize(count) {
        return count < 10 ? 40 : count < 25 ? 46 : 52;
    }

    // ---------- pagina /map ----------

    function initObservationMap(container, config) {
        var text = config.text;
        var form = document.getElementById('map-filter-form');
        var filterCollapse = document.getElementById('map-filter-collapse');
        var filterCountBadge = document.querySelector('[data-map-filter-count]');
        var statusBox = document.getElementById('map-status');
        var countEl = document.getElementById('map-count');
        var noCoordinatesEl = document.getElementById('map-no-coordinates');
        var resetButton = form.querySelector('[data-map-filter-reset]');
        var exportLink = document.getElementById('map-export-link');
        var exportWrapper = document.getElementById('map-export-wrapper');

        var standard = standardLayer();
        var map = L.map(container, { layers: [standard] });
        var layersByLabel = {};
        layersByLabel[text.layerStandard] = standard;
        layersByLabel[text.layerTopo] = topoLayer();
        L.control.layers(layersByLabel).addTo(map);
        removeAttributionPrefix(map);
        addScale(map);
        map.setView(DEFAULT_CENTER, DEFAULT_ZOOM);

        var cluster = L.markerClusterGroup({
            maxClusterRadius: 50,
            showCoverageOnHover: false,
            spiderfyOnMaxZoom: true,
            iconCreateFunction: function (group) {
                var points = group.getAllChildMarkers().map(function (marker) { return marker.options.point; });
                var size = clusterSize(points.length);
                return L.divIcon({ className: '', html: clusterHtml(points, config.authenticated), iconSize: [size, size] });
            }
        });
        map.addLayer(cluster);

        addLocateControl(map, text, flashStatus);
        addLegend(map, config);
        fitMapToViewport(map, container, filterCollapse);

        var markersByCode = {};
        var firstLoad = true;

        function checkedValues(name) {
            return Array.prototype.map.call(form.querySelectorAll('input[name="' + name + '"]:checked'),
                function (input) { return input.value; });
        }

        function hasInputs(name) {
            return form.querySelector('input[name="' + name + '"]') != null;
        }

        // toate tipurile/starile bifate = nicio conditie (URL scurt); niciuna = nimic de afisat
        function filterParams() {
            var params = new URLSearchParams();
            var types = checkedValues('types');
            if (types.length < TYPE_ORDER.length) types.forEach(function (type) { params.append('types', type); });
            if (hasInputs('statuses')) {
                var statuses = checkedValues('statuses');
                if (statuses.length < STATUS_COUNT) statuses.forEach(function (status) { params.append('statuses', status); });
            }
            ['observedAtFrom', 'observedAtTo'].forEach(function (name) {
                var input = form.querySelector('input[name="' + name + '"]');
                if (input && input.value) params.set(name, input.value);
            });
            ['onlyMine', 'sentinelOnly'].forEach(function (name) {
                var input = form.querySelector('input[name="' + name + '"]');
                if (input && input.checked) params.set(name, 'true');
            });
            return params;
        }

        // Filtrarea se face IN BROWSER (decizie 2026-10-01): lista completa, vizibila
        // pt nivelul de acces curent, se incarca o singura data (loadAll), iar fiecare
        // schimbare de filtru doar redeseneaza marcajele - instant, fara cerere noua
        // (util pe teren, cu semnal slab). Aceeasi semantica ca pe server (exportul
        // GeoJSON ramane pe server, cu filtrul din URL): toate tipurile/starile bifate =
        // nicio conditie; niciuna bifata = nimic; perioada pe data observatiei in teren.
        function passesFilters(point) {
            var types = checkedValues('types');
            if (types.indexOf(point.type) === -1) return false;
            if (hasInputs('statuses') && point.status != null
                && checkedValues('statuses').indexOf(String(point.status)) === -1) return false;
            var from = form.querySelector('input[name="observedAtFrom"]').value;
            var to = form.querySelector('input[name="observedAtTo"]').value;
            // date ISO (yyyy-MM-dd) - comparatia de text e corecta
            if (from && (!point.observedDate || point.observedDate < from)) return false;
            if (to && (!point.observedDate || point.observedDate > to)) return false;
            var onlyMine = form.querySelector('input[name="onlyMine"]');
            if (onlyMine && onlyMine.checked && !point.mine) return false;
            var sentinelOnly = form.querySelector('input[name="sentinelOnly"]');
            if (sentinelOnly && sentinelOnly.checked && !point.sentinel) return false;
            return true;
        }

        function activeFilterCount() {
            var count = 0;
            if (checkedValues('types').length < TYPE_ORDER.length) count++;
            if (hasInputs('statuses') && checkedValues('statuses').length < STATUS_COUNT) count++;
            ['observedAtFrom', 'observedAtTo'].forEach(function (name) {
                var input = form.querySelector('input[name="' + name + '"]');
                if (input && input.value) count++;
            });
            ['onlyMine', 'sentinelOnly'].forEach(function (name) {
                var input = form.querySelector('input[name="' + name + '"]');
                if (input && input.checked) count++;
            });
            return count;
        }

        function showStatus(message) {
            statusBox.textContent = message || '';
            statusBox.classList.toggle('d-none', !message);
        }

        // mesaj temporar (ex. locatia nu a putut fi determinata); revine apoi la mesajul
        // anterior (ex. "Nicio observatie..."), daca intre timp nu l-a inlocuit altcineva
        function flashStatus(message) {
            var previous = statusBox.classList.contains('d-none') ? '' : statusBox.textContent;
            showStatus(message);
            setTimeout(function () {
                if (statusBox.textContent === message) showStatus(previous);
            }, 6000);
        }

        function updateFilterIndicators() {
            var count = activeFilterCount();
            resetButton.classList.toggle('d-none', count === 0);
            filterCountBadge.textContent = count;
            filterCountBadge.classList.toggle('d-none', count === 0);
        }

        function updateExportLink(params, count) {
            if (!exportLink) return;
            var enabled = count > 0;
            var query = params.toString();
            exportLink.classList.toggle('disabled', !enabled);
            if (enabled) {
                exportLink.setAttribute('href', exportLink.dataset.exportUrl + (query ? '?' + query : ''));
                exportLink.removeAttribute('aria-disabled');
                exportLink.setAttribute('title', exportLink.dataset.titleEnabled);
                exportWrapper.removeAttribute('title');
                exportWrapper.classList.remove('has-tooltip-hint');
            } else {
                exportLink.removeAttribute('href');
                exportLink.setAttribute('aria-disabled', 'true');
                exportLink.removeAttribute('title');
                exportWrapper.setAttribute('title', exportLink.dataset.titleEmpty);
                exportWrapper.classList.add('has-tooltip-hint');
            }
        }

        function updateSummary(count, withoutCoordinates) {
            countEl.textContent = plural(count, text.countOne, text.countFew, text.countMany);
            noCoordinatesEl.classList.toggle('d-none', withoutCoordinates === 0);
            if (withoutCoordinates > 0) {
                noCoordinatesEl.textContent =
                    plural(withoutCoordinates, text.noCoordinatesOne, text.noCoordinatesFew, text.noCoordinatesMany);
            }
        }

        function renderPoints(points) {
            cluster.clearLayers();
            markersByCode = {};
            var markers = points.map(function (point) {
                var marker = L.marker([point.lat, point.lon], {
                    point: point,
                    icon: markerIcon(point, MARKER_SIZE),
                    title: config.types[point.type] + (point.status != null ? ' · ' + config.statuses[point.status] : '')
                });
                // autoPan: false - pozitia ferestrei si mutarea hartii le face placeBesidePin (V5)
                marker.bindPopup(function () { return popupHtml(point, config); }, {
                    className: 'map-popup', minWidth: 260, maxWidth: 260, autoPan: false
                });
                markersByCode[point.code] = marker;
                return marker;
            });
            cluster.addLayers(markers);
        }

        function focusRequested() {
            if (!config.focus) return false;
            var marker = markersByCode[config.focus];
            config.focus = null;
            if (!marker) return false;
            map.setView(marker.getLatLng(), FOCUS_ZOOM);
            cluster.zoomToShowLayer(marker, function () { marker.openPopup(); });
            return true;
        }

        var allPoints = null;
        var loadedAt = null;
        var lastRefreshFailed = false;
        var refreshing = false;
        var refreshButton = document.getElementById('map-refresh');
        var autoRefreshMs = (Number(config.autoRefreshMinutes) || 0) * 60 * 1000;

        function applyFilters() {
            var params = filterParams();
            var query = params.toString();
            history.replaceState(null, '', location.pathname + (query ? '?' + query : ''));
            updateFilterIndicators();
            if (!allPoints) return;

            var matching = allPoints.filter(passesFilters);
            var onMap = matching.filter(function (p) { return p.lat != null && p.lon != null; });
            renderPoints(onMap);
            updateSummary(onMap.length, matching.length - onMap.length);
            updateExportLink(params, onMap.length);
            showStatus(onMap.length === 0 ? text.empty : null);
            return onMap;
        }

        // Reincarcarea observatiilor (decizie 2026-10-01): lista se incarca la deschiderea
        // paginii, apoi (1) manual, din butonul ↻ de langa total, si (2) automat, cand
        // utilizatorul revine pe tab dupa cel putin app.map.auto-refresh-minutes, sau cand
        // pagina e readusa cu "Inapoi" din memoria browserului (bfcache). O reincarcare
        // pastreaza filtrele, zoom-ul si pozitia hartii; la eroare raman datele vechi, fara
        // mesaj peste harta - doar tooltip-ul butonului spune ca actualizarea n-a reusit.
        function loadAll(isRefresh) {
            if (refreshing) return;
            refreshing = true;
            if (isRefresh) {
                refreshButton.classList.add('map-refreshing');
            } else {
                showStatus(text.loading);
            }
            fetch(config.pointsUrl, {
                headers: { Accept: 'application/json' },
                credentials: 'same-origin',
                cache: 'no-store'
            }).then(function (response) {
                if (!response.ok) throw new Error('HTTP ' + response.status);
                return response.json();
            }).then(function (data) {
                allPoints = data.points;
                loadedAt = Date.now();
                lastRefreshFailed = false;
                var onMap = applyFilters();
                if (firstLoad) {
                    firstLoad = false;
                    if (!focusRequested() && onMap.length > 0) {
                        map.fitBounds(L.latLngBounds(onMap.map(function (p) { return [p.lat, p.lon]; })),
                            { padding: [30, 30], maxZoom: 15 });
                    }
                }
            }).catch(function () {
                if (allPoints) {
                    lastRefreshFailed = true;
                } else {
                    showStatus(text.loadError);
                }
            }).then(function () {
                refreshing = false;
                refreshButton.classList.remove('map-refreshing');
                updateRefreshTitle();
            });
        }

        function updateRefreshTitle() {
            if (!loadedAt) return;
            var age = window.CaliTime ? window.CaliTime.formatRelative(Date.now() - loadedAt) : '';
            refreshButton.title = format(lastRefreshFailed ? text.refreshFailed : text.refreshTitle, [age]);
        }

        // reincarcarea automata nu inchide fereastra unui punct deschis - se amana
        // pana la inchiderea ei (re-desenarea marcajelor ar inchide-o)
        var refreshPendingOnPopupClose = false;
        var popupOpen = false;
        function autoRefresh() {
            if (popupOpen) {
                refreshPendingOnPopupClose = true;
                return;
            }
            loadAll(true);
        }
        map.on('popupopen', function (evt) {
            popupOpen = true;
            placeBesidePin(map, evt.popup);
            // butonul "Vedeti detaliile" e creat aici, dupa initializarea htmx - trebuie
            // procesat explicit ca hx-get sa functioneze. DUPA placeBesidePin: popup.update()
            // reconstruieste continutul ferestrei (innerHTML nou), deci un link procesat
            // inainte ar fi inlocuit cu unul neprocesat (click = fereastra de detalii goala)
            if (window.htmx) window.htmx.process(evt.popup.getElement());
        });
        map.on('popupclose', function () {
            popupOpen = false;
            if (refreshPendingOnPopupClose) {
                refreshPendingOnPopupClose = false;
                loadAll(true);
            }
        });

        refreshButton.addEventListener('click', function () { loadAll(true); });
        // dupa o validare / marcare Sentinela / stergere facuta din fereastra de detalii
        // deschisa pe harta (ReturnOrigin.MAP) - pinul isi schimba imediat starea
        document.body.addEventListener('mapDataChanged', function () { loadAll(true); });
        // varsta datelor e calculata la momentul hover-ului/focus-ului, nu inghetata
        refreshButton.addEventListener('mouseenter', updateRefreshTitle);
        refreshButton.addEventListener('focus', updateRefreshTitle);

        document.addEventListener('visibilitychange', function () {
            if (document.visibilityState === 'visible' && autoRefreshMs > 0 && loadedAt
                && Date.now() - loadedAt >= autoRefreshMs) {
                autoRefresh();
            }
        });
        window.addEventListener('pageshow', function (evt) {
            if (evt.persisted && loadedAt) autoRefresh();
        });

        form.addEventListener('change', applyFilters);
        form.addEventListener('submit', function (evt) {
            evt.preventDefault();
            applyFilters();
        });
        resetButton.addEventListener('click', function () {
            form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
                input.checked = input.name === 'types' || input.name === 'statuses';
            });
            form.querySelectorAll('input[type="date"]').forEach(function (input) { input.value = ''; });
            applyFilters();
        });

        // caruselul de poze din fereastra punctului (continut generat, deci delegare)
        function stepPopupPhoto(gallery, dir) {
            var count = Number(gallery.dataset.count);
            var index = (Number(gallery.dataset.index) + dir + count) % count;
            gallery.dataset.index = index;
            var img = gallery.querySelector('img');
            img.src = photoUrl(config, gallery.dataset.code, index);
            img.alt = format(text.photoAlt, [index + 1, count]);
            gallery.querySelectorAll('.map-popup-dots span').forEach(function (dot, i) {
                dot.classList.toggle('active', i === index);
            });
        }

        container.addEventListener('click', function (evt) {
            var nav = evt.target.closest('.map-popup-nav');
            if (!nav) return;
            evt.preventDefault();
            stepPopupPhoto(nav.closest('.map-popup-photo'), Number(nav.dataset.dir));
        });

        // swipe pe poza, ca in galeria din detalii (app.js): doar pe orizontala, |dx| clar
        // mai mare decat |dy| - derularea verticala a ferestrei ramane a browserului
        // (touch-action: pan-y in main.scss). Ascultare in faza de CAPTURE: Leaflet opreste
        // propagarea touchstart din fereastra (de-aia nici harta nu se misca la swipe)
        var POPUP_SWIPE_MIN_PX = 40;
        var popupSwipe = null;
        container.addEventListener('touchstart', function (evt) {
            var gallery = evt.target instanceof Element && evt.target.closest('.map-popup-photo');
            popupSwipe = gallery && Number(gallery.dataset.count) > 1 && evt.touches.length === 1
                ? { gallery: gallery, x: evt.touches[0].clientX, y: evt.touches[0].clientY }
                : null;
        }, { capture: true, passive: true });
        container.addEventListener('touchend', function (evt) {
            if (!popupSwipe) return;
            var touch = evt.changedTouches[0];
            var dx = touch.clientX - popupSwipe.x;
            var dy = touch.clientY - popupSwipe.y;
            var gallery = popupSwipe.gallery;
            popupSwipe = null;
            if (Math.abs(dx) < POPUP_SWIPE_MIN_PX || Math.abs(dx) < 1.5 * Math.abs(dy)) return;
            // spre stanga = poza urmatoare, ca in orice galerie de telefon
            stepPopupPhoto(gallery, dx < 0 ? 1 : -1);
        }, { capture: true, passive: true });
        container.addEventListener('touchcancel', function () {
            popupSwipe = null;
        }, { capture: true, passive: true });

        loadAll(false);
    }

    // Fereastra punctului langa pin (varianta V5, docs/mockup-map-popup-center.html):
    // in DREAPTA pinului, centrata vertical pe el, cu sageata spre stanga. Pe hartile late
    // pinul ajunge in centrul hartii; pe cele inguste (mobil) se centreaza blocul
    // pin + fereastra. Pe hartile joase fereastra se limiteaza la inaltimea hartii
    // (continut derulabil, bara de titlu fixa). Pozitionata ascunsa, apoi afisata,
    // ca sa nu "sara" din pozitia implicita a Leaflet.
    var POPUP_SIDE_GAP = 12;
    var POPUP_MAP_MARGIN = 10;

    function placeBesidePin(map, popup) {
        var el = popup.getElement();
        var wrapper = el.querySelector('.leaflet-popup-content-wrapper');
        el.classList.add('map-popup-beside');
        el.style.visibility = 'hidden';
        // valorile unei deschideri anterioare a aceleiasi ferestre
        popup.options.maxHeight = null;
        popup.options.offset = L.point(0, 7);
        popup.update();

        var size = map.getSize();
        if (wrapper.offsetHeight > size.y - 2 * POPUP_MAP_MARGIN) {
            popup.options.maxHeight = size.y - 2 * POPUP_MAP_MARGIN;
            popup.update();
        }
        var w = wrapper.offsetWidth;
        var h = wrapper.offsetHeight;
        var pinHalfWidth = MARKER_SIZE / 2;
        // ancora Leaflet = varful de sus al pinului (popupAnchor [0, -MARKER_SIZE]); fereastra
        // la dreapta pinului, cu centrul vertical la mijlocul pinului
        popup.options.offset = L.point(pinHalfWidth + POPUP_SIDE_GAP + w / 2, MARKER_SIZE / 2 + h / 2);
        popup.update();

        var tip = map.latLngToContainerPoint(popup.getLatLng());
        var pinCenter = L.point(tip.x, tip.y - MARKER_SIZE / 2 - 2);
        var blockWidth = 2 * pinHalfWidth + POPUP_SIDE_GAP + w;
        var fitsWithPinCentered = size.x >= 2 * (pinHalfWidth + POPUP_SIDE_GAP + w) + 2 * POPUP_MAP_MARGIN;
        var targetX = fitsWithPinCentered ? size.x / 2 : Math.max(POPUP_MAP_MARGIN + pinHalfWidth, (size.x - blockWidth) / 2 + pinHalfWidth);
        el.style.visibility = '';
        map.panBy(L.point(pinCenter.x - targetX, pinCenter.y - size.y / 2), { animate: true });
    }

    function photoUrl(config, code, index) {
        return config.photoUrl + encodeURIComponent(code) + '/' + index;
    }

    function galleryHtml(point, config) {
        var text = config.text;
        if (!point.photoCount) {
            return '<div class="map-popup-nophoto"><i class="bi bi-image" aria-hidden="true"></i> ' + escapeHtml(text.noPhoto) + '</div>';
        }
        var html = '<div class="map-popup-photo" data-code="' + escapeHtml(point.code) + '" data-index="0" data-count="' + point.photoCount + '">'
            + '<img src="' + escapeHtml(photoUrl(config, point.code, 0)) + '" alt="' + escapeHtml(format(text.photoAlt, [1, point.photoCount])) + '">';
        if (point.photoCount > 1) {
            html += '<button type="button" class="map-popup-nav map-popup-nav-prev" data-dir="-1" aria-label="' + escapeHtml(text.photoPrev) + '"><i class="bi bi-chevron-left" aria-hidden="true"></i></button>'
                + '<button type="button" class="map-popup-nav map-popup-nav-next" data-dir="1" aria-label="' + escapeHtml(text.photoNext) + '"><i class="bi bi-chevron-right" aria-hidden="true"></i></button>'
                + '<div class="map-popup-dots">';
            for (var i = 0; i < point.photoCount; i++) {
                html += '<span class="' + (i === 0 ? 'active' : '') + '"></span>';
            }
            html += '</div>';
        }
        return html + '</div>';
    }

    // Campurile modulului (decizie 2026-10-01): valorile din liste si cele numerice
    // sunt publice; textul liber (specia "Alta specie", tipul insectei, descrierea)
    // vine de la server doar pt utilizatorii autentificati. Etichete si culori din
    // aceleasi chei/clase ca listarile (stage-badge-N, disturbance-type-badge-N,
    // severity-badge-N, bara de compozitie a solului).
    var POPUP_DETAILS_MAX = 120;
    // fereastra de detalii a fiecarui modul (fragments/modals.html, inclusa global in layout)
    var DETAILS_MODALS = { PHENOLOGY: 'phenology-modal', DISTURBANCE: 'disturbance-modal', SOIL: 'soil-modal' };
    var SOIL_CLASSES = ['moss', 'litter', 'plants', 'bareSoil'];
    var AREA_FORMAT = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 2 });

    function truncate(value, max) {
        var textValue = String(value).trim();
        return textValue.length > max ? textValue.substring(0, max).trim() + '…' : textValue;
    }

    // randul de sus al ferestrei (C1, docs/mockup-map-popup-compact.html): starea +
    // badge-urile modulului + data observatiei, pe acelasi rand
    function moduleBadgesHtml(point, config) {
        var f = point.fields || {};
        var labels = config.fieldLabels || {};
        var badges = point.status != null
            ? '<span class="badge status-badge-' + point.status + '">' + escapeHtml(config.statuses[point.status]) + '</span>' : '';
        if (f.stage != null && labels.stages && labels.stages[f.stage]) {
            badges += '<span class="badge stage-badge-' + f.stage + '">' + escapeHtml(labels.stages[f.stage]) + '</span>';
        }
        (f.disturbanceTypes || []).forEach(function (code) {
            if (labels.disturbanceTypes && labels.disturbanceTypes[code]) {
                badges += '<span class="badge disturbance-type-badge-' + code + '">' + escapeHtml(labels.disturbanceTypes[code]) + '</span>';
            }
        });
        if (f.severity != null && labels.severities && labels.severities[f.severity]) {
            badges += '<span class="badge severity-badge-' + f.severity + '">' + f.severity + ' - ' + escapeHtml(labels.severities[f.severity]) + '</span>';
        }
        var date = point.observedAt ? '<span class="map-popup-date">' + escapeHtml(point.observedAt) + '</span>' : '';
        return (badges || date) ? '<div class="map-popup-badges">' + badges + date + '</div>' : '';
    }

    // un rand de text, taiat cu "…" daca nu incape; textul intreg in tooltip
    function oneLineRow(value) {
        return '<div class="map-popup-row map-popup-one-line" title="' + escapeHtml(value) + '">' + escapeHtml(value) + '</div>';
    }

    function moduleRowsHtml(point, config) {
        var f = point.fields || {};
        var labels = config.fieldLabels || {};
        var rows = '';
        if (f.species) {
            var species = f.speciesOther ? f.speciesOther : (labels.species && labels.species[f.species]) || f.species;
            rows += oneLineRow(labels.speciesLabel + ': ' + species);
        }
        if (f.affectedAreaSqm != null) {
            rows += oneLineRow(labels.affectedArea + ': ' + AREA_FORMAT.format(f.affectedAreaSqm) + ' m²');
        }
        if (f.insectType) {
            rows += oneLineRow(labels.insectType + ': ' + f.insectType);
        }
        if (f.moss != null && labels.soil) {
            // bara + compozitia pe 4 coloane; denumirile complete in tooltip
            var title = SOIL_CLASSES.map(function (c) { return labels.soil[c] + ': ' + f[c] + '%'; }).join(' · ');
            // cate o coloana pe clasa: bulina in culoarea segmentului + denumirea, procentul
            // dedesubt ("8 cu buline" din docs/mockup-map-soil-legend.html)
            var legend = SOIL_CLASSES.map(function (c) {
                return '<span><span class="map-popup-soil-name"><span class="map-popup-soil-dot soil-composition-swatch-' + c + '"></span>'
                    + escapeHtml((labels.soilShort || labels.soil)[c]) + '</span><span class="map-popup-soil-pct">' + Number(f[c]) + '%</span></span>';
            }).join('');
            rows += '<div class="map-popup-row" title="' + escapeHtml(title) + '"><div class="soil-composition-mini-bar">'
                + SOIL_CLASSES.map(function (c) {
                    return '<span class="soil-composition-mini-segment soil-composition-mini-segment-' + c + '" style="width:' + Number(f[c]) + '%"></span>';
                }).join('') + '</div><div class="map-popup-soil-legend">' + legend + '</div></div>';
        }
        if (f.seedlingsPresent != null) {
            rows += '<div class="map-popup-row">' + escapeHtml(labels.seedlings) + ': ' + escapeHtml(f.seedlingsPresent ? labels.yes : labels.no) + '</div>';
        }
        return rows;
    }

    function popupHtml(point, config) {
        var text = config.text;
        // bara de titlu (varianta H3, docs/mockup-map-popup-header.html): tipul + codul,
        // in culoarea aplicatiei, ca antetul ferestrelor de detalii; × sta in bara, nimic
        // peste poza. "· COD" e o bucata indivizibila: peste ~6 cifre trece intreg pe randul 2
        var html = '<div class="map-popup-header map-type-' + point.type + '">'
            + '<span class="map-popup-type-dot"><i class="bi ' + TYPE_ICONS[point.type] + '" aria-hidden="true"></i></span>'
            + '<span class="map-popup-title"><span>' + escapeHtml(config.types[point.type]) + '</span>'
            + '<span class="map-popup-code"><span class="map-popup-sep">·</span> ' + escapeHtml(point.code) + '</span></span></div>'
            + galleryHtml(point, config)
            // fara coordonate (C1): pinul arata locul, coordonatele exacte sunt in detalii
            + '<div class="map-popup-body">' + moduleBadgesHtml(point, config)
            + moduleRowsHtml(point, config);
        if (point.sentinel) {
            html += '<div class="text-success small mt-1"><i class="bi bi-tree-fill" aria-hidden="true"></i> ' + escapeHtml(text.sentinel) + '</div>';
        }
        if (point.details) {
            html += '<div class="map-popup-details map-popup-one-line" title="' + escapeHtml(truncate(point.details, POPUP_DETAILS_MAX)) + '">'
                + escapeHtml(point.details) + '</div>';
        }
        // actiunea: doar pt autentificati ("Vedeti detaliile"); vizitatorii nu au buton
        // (decizie 2026-10-01 - dupa autentificare nu s-ar fi intors la observatie, iar
        // "Autentificare" e oricum in meniu), fereastra lor se termina cu pozitia
        if (point.detailsPath) {
            // detaliile se deschid in fereastra modulului (ca in Listarea Observatii), prin
            // htmx, cu origin=MAP: validarea/stergerea din ele nu mai parasesc harta (vezi
            // ReturnOrigin.MAP); href ramane pagina completa, ca rezerva fara JavaScript
            var url = config.baseUrl + point.detailsPath.substring(1);
            var modalId = DETAILS_MODALS[point.type];
            html += '<div class="map-popup-actions"><a class="map-popup-link" href="' + escapeHtml(url) + '"'
                + ' hx-get="' + escapeHtml(url + '?origin=MAP') + '" hx-target="#' + modalId + '-body"'
                + ' data-bs-toggle="modal" data-bs-target="#' + modalId + '">'
                + escapeHtml(text.details) + ' <i class="bi bi-arrow-right" aria-hidden="true"></i></a></div>';
        }
        return html + '</div>';
    }

    // Inaltimea hartii = spatiul ramas in ecran, de la pozitia ei pana deasupra
    // footer-ului fix (desktop) - MASURAT, nu o valoare fixa in CSS: zona de filtre
    // se deschide/inchide (si are inaltimi diferite pt vizitator / autentificat),
    // iar footer-ul are inaltimea lui proprie (--app-footer-height, masurata deja de
    // app.js; 0 pe mobil, unde footer-ul nu e fix). Minimul (380px) ramane plasa de
    // siguranta pe ecranele joase.
    var MIN_MAP_HEIGHT = 380;
    var MAP_BOTTOM_GAP = 8;

    function fitMapToViewport(map, container, filterCollapse) {
        var scheduled = false;
        function fit() {
            scheduled = false;
            var footerHeight = parseFloat(getComputedStyle(document.documentElement)
                .getPropertyValue('--app-footer-height')) || 0;
            var top = container.getBoundingClientRect().top + window.scrollY;
            var available = window.innerHeight - top - footerHeight - MAP_BOTTOM_GAP;
            var height = Math.max(MIN_MAP_HEIGHT, Math.floor(available));
            if (container.offsetHeight !== height) {
                container.style.height = height + 'px';
                map.invalidateSize();
            }
        }
        function schedule() {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(fit);
        }
        fit();
        window.addEventListener('resize', schedule);
        if (window.ResizeObserver) {
            // zona de filtre (deschisa/inchisa, animat) si footer-ul (siglele se
            // incarca tarziu) isi schimba inaltimea fara resize de fereastra
            var observer = new ResizeObserver(schedule);
            [filterCollapse, document.querySelector('footer')]
                .forEach(function (el) { if (el) observer.observe(el); });
        }
    }

    // legenda porneste restransa pe orice ecran (cerere user 2026-10-01) - doar
    // titlul "Legenda" vizibil, se deschide la click; sus-stanga, langa +/- (2026-10-02)
    function addLegend(map, config) {
        var collapsed = true;
        var text = config.text;
        var legend = L.control({ position: 'topleft' });
        legend.onAdd = function () {
            var div = L.DomUtil.create('div', 'map-legend' + (collapsed ? ' map-legend-collapsed' : ''));
            var swatch = function (point) {
                return '<span class="map-legend-swatch">' + markerHtml(point) + '</span>';
            };
            var html = '<button type="button" class="map-legend-toggle" aria-expanded="' + !collapsed + '">'
                + '<span>' + escapeHtml(text.legendTitle) + '</span><i class="bi bi-chevron-down" aria-hidden="true"></i></button>'
                + '<div class="map-legend-body"><h3>' + escapeHtml(text.legendType) + '</h3>';
            TYPE_ORDER.forEach(function (type) {
                html += '<div class="map-legend-item">' + swatch({ type: type }) + '<span>' + escapeHtml(config.types[type]) + '</span></div>';
            });
            if (config.authenticated) {
                html += '<h3>' + escapeHtml(text.legendStatus) + '</h3>';
                Object.keys(config.statuses).forEach(function (status) {
                    html += '<div class="map-legend-item">' + swatch({ type: 'PHENOLOGY', status: Number(status) })
                        + '<span>' + escapeHtml(config.statuses[status]) + '</span></div>';
                });
            }
            var sample = TYPE_ORDER.map(function (type, i) { return { type: type, status: i === 1 ? STATUS_PENDING : 2 }; });
            html += '<h3>' + escapeHtml(text.legendGroup) + '</h3><div class="map-legend-item">'
                + '<span class="map-legend-swatch map-legend-swatch-cluster">' + clusterHtml(sample, config.authenticated) + '</span>'
                + '<span>' + escapeHtml(text.legendGroupCount) + '<br>' + escapeHtml(text.legendGroupRing)
                + (config.authenticated ? '<br><i class="bi bi-clock-fill text-body-secondary" aria-hidden="true"></i> = ' + escapeHtml(text.legendGroupPending) : '')
                + '</span></div>'
                + '<div class="map-legend-item mt-2">' + swatch({ type: 'PHENOLOGY', sentinel: true }) + '<span>' + escapeHtml(text.legendSentinel) + '</span></div>'
                + '</div>';
            div.innerHTML = html;
            L.DomEvent.disableClickPropagation(div);
            L.DomEvent.disableScrollPropagation(div);
            var toggle = div.querySelector('.map-legend-toggle');
            toggle.addEventListener('click', function () {
                var nowCollapsed = div.classList.toggle('map-legend-collapsed');
                toggle.setAttribute('aria-expanded', String(!nowCollapsed));
            });
            return div;
        };
        legend.addTo(map);
    }

    // atribuirea ramane DOAR cu sursele hartii (obligatorii prin licenta: OSM - ODbL,
    // OpenTopoMap - CC-BY-SA); prefixul implicit "Leaflet" + steag nu e cerut de licenta
    // bibliotecii (BSD-2, nota de copyright e in leaflet.js) - scos, decizie 2026-10-05
    function removeAttributionPrefix(map) {
        map.attributionControl.setPrefix(false);
    }

    // bara de scara (ex. "500 m"), doar metric; stanga jos - dreapta jos e atribuirea
    function addScale(map) {
        var scale = L.control.scale({ metric: true, imperial: false, position: 'bottomleft' }).addTo(map);
        var scaleEl = scale.getContainer();
        var attributionEl = map.attributionControl.getContainer();
        // pe ecrane inguste, atribuirea lunga a stratului Topografic ocupa tot randul de
        // jos (la 320px chiar doua randuri) si acoperea scara - scara urca deasupra ei,
        // DOAR cand chiar se suprapun (latimea scarii variaza cu zoom-ul)
        function keepClearOfAttribution() {
            scaleEl.style.marginBottom = '';
            var s = scaleEl.getBoundingClientRect();
            var a = attributionEl.getBoundingClientRect();
            if (a.left < s.right && a.top < s.bottom) {
                var current = parseFloat(getComputedStyle(scaleEl).marginBottom) || 0;
                scaleEl.style.marginBottom = (current + s.bottom - a.top + 4) + 'px';
            }
        }
        map.on('baselayerchange zoomend resize', function () {
            requestAnimationFrame(keepClearOfAttribution);
        });
        map.whenReady(function () { requestAnimationFrame(keepClearOfAttribution); });
    }

    // Butonul "Locatia mea" (sub +/-): prima apasare porneste urmarirea pozitiei
    // (punct + cercul de precizie, actualizate cat timp e activ) si centreaza harta
    // O SINGURA DATA - apoi utilizatorul poate muta harta liber; a doua apasare opreste.
    function addLocateControl(map, text, notifyError) {
        var LOCATE_ZOOM = 15;
        var active = false;
        var centered = false;
        var dot = null;
        var circle = null;
        var button;

        function setActive(value) {
            active = value;
            var label = value ? text.locateStop : text.locateTitle;
            button.classList.toggle('map-locate-active', value);
            button.setAttribute('title', label);
            button.setAttribute('aria-label', label);
            button.setAttribute('aria-pressed', String(value));
        }

        function clearPosition() {
            if (dot) map.removeLayer(dot);
            if (circle) map.removeLayer(circle);
            dot = null;
            circle = null;
        }

        // al treilea buton IN bara +/- (nu control separat): legenda sta in dreapta barei
        // (clear: none), iar un control nou in acelasi colt ar sari sub legenda deschisa
        button = L.DomUtil.create('a', 'map-locate', map.zoomControl.getContainer());
        button.href = '#';
        button.setAttribute('role', 'button');
        button.innerHTML = '<i class="bi bi-crosshair" aria-hidden="true"></i>';
        setActive(false);
        L.DomEvent.disableClickPropagation(button);
        L.DomEvent.on(button, 'click', function (evt) {
            L.DomEvent.preventDefault(evt);
            if (active) {
                map.stopLocate();
                clearPosition();
                setActive(false);
            } else {
                centered = false;
                setActive(true);
                // timeout mai mare decat implicitul Leaflet (10 s): prima pozitie GPS
                // pe teren, cu cerul partial acoperit, poate veni greu
                map.locate({ watch: true, enableHighAccuracy: true, timeout: 30000 });
            }
        });

        map.on('locationfound', function (evt) {
            if (!active) return;
            if (dot) {
                dot.setLatLng(evt.latlng);
                circle.setLatLng(evt.latlng).setRadius(evt.accuracy);
            } else {
                var primary = cssVar('--bs-primary');
                circle = L.circle(evt.latlng, {
                    radius: evt.accuracy, color: primary, weight: 1, fillOpacity: 0.12, interactive: false
                }).addTo(map);
                dot = L.circleMarker(evt.latlng, {
                    radius: 7, color: cssVar('--bs-white'), weight: 2,
                    fillColor: primary, fillOpacity: 1, interactive: false
                }).addTo(map);
            }
            if (!centered) {
                centered = true;
                map.setView(evt.latlng, Math.max(map.getZoom(), LOCATE_ZOOM));
            }
        });

        // dupa o pozitie gasita, un timeout ulterior al urmaririi nu sterge punctul
        // (ramane ultima pozitie cunoscuta); refuzul permisiunii opreste mereu
        map.on('locationerror', function (evt) {
            if (!active) return;
            if (dot && evt.code !== 1) return;
            map.stopLocate();
            clearPosition();
            setActive(false);
            notifyError(text.locateError);
        });
    }

    // ---------- mini-harta (detalii observatie / validare Ranger) ----------

    // Pin-ul observatiei, cercul de precizie GPS, observatiile din apropiere
    // (estompate; cele de acelasi tip, foarte aproape = posibile duplicate,
    // evidentiate). Zoom-ul cu rotita e dezactivat, ca harta sa nu "fure"
    // derularea ferestrei. In modal, elementul are latime 0 pana se deschide
    // complet - harta se redimensioneaza si se incadreaza la prima latime reala.
    function initMinimap(el) {
        var data = el.dataset;
        var summaryEl = el.parentElement.querySelector('[data-minimap-summary]');
        fetch(data.nearbyUrl, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (response) {
                if (!response.ok) throw new Error('HTTP ' + response.status);
                return response.json();
            })
            .then(function (result) {
                // deschise din harta mare: doar linia de rezumat, fara mini-harta
                if (el.hasAttribute('data-minimap-summary-only')) {
                    renderNearbySummary(summaryEl, data, result, true);
                } else {
                    renderMinimap(el, summaryEl, result);
                }
            })
            .catch(function () {
                if (el.hasAttribute('data-minimap-summary-only')) {
                    if (summaryEl) summaryEl.textContent = data.textNearbyLoadError;
                    return;
                }
                el.classList.add('d-flex', 'align-items-center', 'justify-content-center', 'text-body-secondary', 'small');
                el.textContent = data.textLoadError;
            });
    }

    // "N observatii pe o raza de R m · M posibile duplicate (acelasi tip, sub D m)".
    // Sub mini-harta (liste): o linie mica, cu iconita. Doar rezumat (detalii deschise
    // din harta mare, rand eticheta | valoare): duplicatele pe rand separat, ca sa
    // inceapa la marginea coloanei si sa nu se rupa la mijloc pe mobil.
    function renderNearbySummary(summaryEl, data, result, summaryOnly) {
        if (!summaryEl) return;
        var count = result.nearby.length;
        var duplicates = result.nearby.filter(function (near) { return near.possibleDuplicate; }).length;
        var summary = escapeHtml(count === 0
            ? format(data.textNearbyNone, [0, result.radiusMeters])
            : plural(count, data.textNearbyOne, data.textNearbyFew, data.textNearbyMany, [result.radiusMeters]));
        var duplicatesText = duplicates > 0
            ? escapeHtml(plural(duplicates, data.textDuplicatesOne, data.textDuplicatesFew, data.textDuplicatesMany, [result.duplicateRadiusMeters]))
            : null;
        if (summaryOnly) {
            summaryEl.innerHTML = '<div>' + summary + '</div>'
                + (duplicatesText ? '<div class="text-danger">' + duplicatesText + '</div>' : '');
            return;
        }
        summaryEl.innerHTML = '<i class="bi bi-geo" aria-hidden="true"></i> ' + summary
            + (duplicatesText ? ' · <span class="text-danger">' + duplicatesText + '</span>' : '');
    }

    function renderMinimap(el, summaryEl, result) {
        var data = el.dataset;
        var center = result.observation;
        var map = L.map(el, { scrollWheelZoom: false });
        standardLayer().addTo(map);
        removeAttributionPrefix(map);
        addScale(map);

        var centerLatLng = L.latLng(center.lat, center.lon);
        var bounds = centerLatLng.toBounds(Math.max(center.accuracy || 0, 30) * 2);
        if (center.accuracy) {
            var primary = cssVar('--bs-primary');
            L.circle(centerLatLng, { radius: center.accuracy, color: primary, weight: 2, dashArray: '5 5', fillOpacity: 0.12 }).addTo(map);
            var legend = L.control({ position: 'topright' });
            legend.onAdd = function () {
                var div = L.DomUtil.create('div', 'minimap-legend');
                div.innerHTML = '<span class="minimap-accuracy-swatch" aria-hidden="true"></span> '
                    + escapeHtml(format(data.textAccuracy, [Math.round(center.accuracy)]));
                return div;
            };
            legend.addTo(map);
        }

        result.nearby.forEach(function (near) {
            var latLng = L.latLng(near.point.lat, near.point.lon);
            var tooltip = format(near.possibleDuplicate ? data.textDuplicateTooltip : data.textNearbyTooltip,
                [near.point.code, near.distanceMeters]);
            L.marker(latLng, {
                icon: markerIcon(near.point, NEAR_MARKER_SIZE, 'map-marker-near' + (near.possibleDuplicate ? ' map-marker-duplicate' : '')),
                title: tooltip,
                keyboard: false
            }).bindTooltip(escapeHtml(tooltip)).addTo(map);
            bounds.extend(latLng);
        });

        L.marker(centerLatLng, { icon: markerIcon(center, MARKER_SIZE), zIndexOffset: 1000, title: center.code }).addTo(map);

        renderNearbySummary(summaryEl, data, result);

        var fitted = false;
        function fit() {
            if (el.clientWidth === 0) return;
            map.invalidateSize();
            if (!fitted) {
                fitted = true;
                map.fitBounds(bounds, { padding: [28, 28], maxZoom: 17 });
            }
        }
        fit();
        if (window.ResizeObserver) {
            new ResizeObserver(fit).observe(el);
        }
        if (!fitted) map.setView(centerLatLng, 16);
    }

    window.CaliMap = { initMinimap: initMinimap };

    // o singura data: ca script "defer" pe /map, map.js ruleaza cand documentul e
    // deja parsat (readyState "interactive"), INAINTE de DOMContentLoaded - ambele
    // cai ar initializa altfel aceeasi harta ("Map container is already initialized")
    function initPageMap() {
        var container = document.getElementById('observation-map');
        if (container && window.CALI_MAP_CONFIG && !container._leaflet_id) {
            initObservationMap(container, window.CALI_MAP_CONFIG);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initPageMap);
    } else {
        initPageMap();
    }
})();
